import { NAME } from './constants';

// Membre dont l'abonnement a expiré depuis moins d'un an : connecté en consultation
// (cagnotte, bons d'achat déjà commandés, virement) mais offres bloquées (tracking,
// interstitiel, codes promo, achat de bons d'achat).
export const isLimitedMember = state => !!state[NAME].limited;



// WEBPACK FOOTER //
// ./src/services/authentication/selector.js